// ไอคอน 💡 ใน NavBar (ทุกหน้า) — badge จำนวนเรื่องที่ยังไม่ได้จัดการวันนี้ คลิกแล้วเปิด top 3 โดยไม่ต้องเปลี่ยนหน้า
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Box, Button, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import InsightCard from './InsightCard';
import InsightRowsDrawer, { rowActionFor } from './InsightRowsDrawer';
import useInsightTasks, { logInsightEvent } from './useInsightTasks';
import { useInsightMe } from './useInsightInline';

export default function InsightNavButton() {
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState(null);
  const [rowsTask, setRowsTask] = useState(null);
  const { data: me } = useInsightMe();
  const enabled = Boolean(me?.channels?.navbar);
  const { data: daily, actionsFor, readOnly } = useInsightTasks(enabled);
  if (!enabled) return null;

  const tasks = daily?.tasks || [];
  const open = tasks.filter(t => t.status === 'open');
  const top = (open.length ? open : tasks).slice(0, 3);

  const handleOpen = e => {
    setAnchor(e.currentTarget);
    top.forEach(t => logInsightEvent(t.id, 'seen_popover'));
  };

  return (
    <>
      <Tooltip title="insight วันนี้">
        <IconButton
          color="inherit" onClick={handleOpen} aria-label="insight วันนี้"
          sx={{ width: 36, height: 36, bgcolor: 'rgba(255,255,255,0.10)', '&:hover': { bgcolor: 'rgba(255,255,255,0.20)' } }}
        >
          <Badge badgeContent={open.length} color="warning" max={9}>
            <LightbulbOutlinedIcon sx={{ fontSize: 20 }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: { xs: 'calc(100vw - 32px)', sm: 400 }, maxHeight: '75vh', p: 1.5 } }}
      >
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
          insight วันนี้{tasks.length ? ` · เหลือ ${open.length} จาก ${tasks.length} เรื่อง` : ''}
        </Typography>
        {!tasks.length && (
          <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
            {daily?.status === 'pending' ? 'insight ของวันนี้จะพร้อมหลัง 06:00 น.' : 'วันนี้ยังไม่มีเรื่องที่ควรดู'}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {top.map(t => (
            <InsightCard key={t.id} task={t} minWidth={0} actions={actionsFor(t, { onOpenRows: task => { setAnchor(null); setRowsTask(task); } })} />
          ))}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Button size="small" onClick={() => { setAnchor(null); navigate('/my-tasks'); }}>ดูทั้งหมด / ประวัติ ›</Button>
        </Box>
      </Popover>
      <InsightRowsDrawer
        key={rowsTask?.id || 'none'}
        open={Boolean(rowsTask)} onClose={() => setRowsTask(null)}
        url={rowsTask ? `/api/insight/tasks/${rowsTask.id}/rows` : null}
        title={rowsTask?.title}
        onDownload={rowsTask ? () => actionsFor(rowsTask).download() : undefined}
        onCopy={rowsTask ? () => logInsightEvent(rowsTask.id, 'copy') : undefined}
        rowAction={rowActionFor(rowsTask, readOnly)}
      />
    </>
  );
}
